import { useState } from "react";

// Bluetooth service UUIDs
const FTMS_SERVICE_UUID = 0x1826;
const CYCLING_POWER_SERVICE_UUID = 0x1818;
const CSCS_SERVICE_UUID = 0x1816;
const FITNESS_MACHINE_CONTROL_POINT_UUID = 0x2ad9;
const CYCLING_POWER_MEASUREMENT_UUID = 0x2a63;
const CSC_MEASUREMENT_UUID = 0x2A5B;
// Heart Rate (BPM) UUIDs
const HEART_RATE_SERVICE_UUID = 0x180d;
const HEART_RATE_MEASUREMENT_UUID = 0x2a37;

export const useHomeTrainerBluetooth = (alertDlg, confirm, isMobile, simulate) => {
  // Bluetooth state
  const [serviceFTMS, setServiceFTMS] = useState(null);
  const [serviceCP, setServiceCP] = useState(null);
  const [serviceCSCS, setServiceCSCS] = useState(null);
  const [serviceBPM, setServiceBPM] = useState(null);
  const [canErgControl, setCanErgControl] = useState(false);
  const [isConnected, setIsConnected] = useState(false);
  const [isBPMConnected, setIsBPMConnected] = useState(false);
  const [deviceHT, setDeviceHT] = useState(null);
  const [deviceBPM, setDeviceBPM] = useState(null);

  // Sensor data state
  const [currentCadence, setCurrentCadence] = useState(null);
  const [currentPower, setCurrentPower] = useState(null);
  const [currentBPM, setCurrentBPM] = useState(null);
  const [lastUpdatePower, setLastUpdatePower] = useState(Date.now());
  const [lastUpdateCad, setLastUpdateCad] = useState(Date.now());

  // Debug data
  const [currentHTValueCP, setCurrentHTValueCP] = useState(null);
  const [currentHTValueCSCS, setCurrentHTValueCSCS] = useState(null);

  // Variables for cadence calculations
  let previousTimestamp = null;
  let previousCrankRevolutions = null;
  let lastUpdate = null;

  const handleCharacteristicValueChangedBPM = (event) => {
    const value = event.target.value;
    const heartRate = value.getUint8(1); // Heart Rate BPM
    console.log(`Heart Rate: ${heartRate} BPM`);
    setCurrentBPM(heartRate);
  };

  const handleCharacteristicValueChangedCP = (event, withCadence) => {
    const value = event.target.value;
    // Convert DataView to an array of bytes for storage
    const buffer = new ArrayBuffer(value.byteLength);
    const view = new Uint8Array(buffer);
    for (let i = 0; i < value.byteLength; i++) {
      view[i] = value.getUint8(i);
    }
    setCurrentHTValueCP(view); //store for debug

    const flags = value.getUint16(0, true); // Read flags field
    // Instantaneous Power field (always present, INT16)
    const instantaneousPower = value.getInt16(2, true);
    setLastUpdatePower(Date.now());
    console.log(`Instantaneous Power: ${instantaneousPower} Watts`);
    setCurrentPower(instantaneousPower);

    // Check for other optional data based on flags
    // Example: Check if Crank Revolution Data is present (bit 5)
    if (withCadence && flags & (1 << 5)) {
      console.log("using CP cadence")
      // Bitwise to check if the 6th bit is set
      let crankRevolutions, lastCrankEventTime;
      if (value.byteLength === 14) {
        // Use offsets for a 14-byte array
        crankRevolutions = value.getUint16(10, true);
        lastCrankEventTime = value.getUint16(12, true);
      } else if (value.byteLength === 16) {
        // Use offsets for a 16-byte array
        crankRevolutions = value.getUint16(12, true);
        lastCrankEventTime = value.getUint16(14, true);
      } else {
        crankRevolutions = value.getUint16(10, true); //testing that, Suito initial
        lastCrankEventTime = value.getUint16(12, true);
        console.error("Unsupported value length:", value.byteLength);
      }

      if (previousCrankRevolutions != null && previousTimestamp != null) {
        const timeDifference = (lastCrankEventTime - previousTimestamp) / 1024; // Convert to seconds
        const revolutionsDifference =
          crankRevolutions - previousCrankRevolutions;

        if (revolutionsDifference > 0 || Date.now() - lastUpdate >= 3000) {
          // Basically if not even one rotation in 3 sec, RMP drop to zero.
          const cadence = (revolutionsDifference / timeDifference) * 60; // RPM
          console.log(`Cadence CP: ${cadence.toFixed(2)} RPM`);
          setCurrentCadence(Math.round(cadence) >= 0 ? Math.round(cadence) : 0);
          lastUpdate = Date.now()
          setLastUpdateCad(lastUpdate);
          previousTimestamp = lastCrankEventTime;
          previousCrankRevolutions = crankRevolutions;
        }
      } else {
        previousTimestamp = lastCrankEventTime;
        previousCrankRevolutions = crankRevolutions;
      }
    }

    // You can add similar checks and calculations for other data based on other bits
  };

  const handleCharacteristicValueChangedCSCS = (event) => {
    const value = event.target.value;

    if (!value || value.byteLength === 0) {
      console.warn("Received empty characteristic data.");
      return;
    }

    // Convert DataView to an array of bytes for debugging
    const rawData = new Uint8Array(value.buffer);
    setCurrentHTValueCSCS(rawData); // Store raw data

    const flags = value.getUint8(0);
    let index = 1;

    const wheelRevolutionDataPresent = flags & 0x01;
    const crankRevolutionDataPresent = flags & 0x02;

    let cadence = null; // Default to null to track valid updates

    if (crankRevolutionDataPresent) {


      // Skip Wheel Revolution Data if present
      if (wheelRevolutionDataPresent) {

        index += 6;
      }

      // Extract crank revolutions (Little-endian)
      console.log("index crank rev", index)
      const crankRevolutions = value.getUint16(index, true);
      index += 2;
      console.log("index crank time rev", index)

      // Extract crank event time (Little-endian, in 1/1024 sec)
      const crankEventTime = value.getUint16(index, true);

      console.log(`Crank Revolutions: ${crankRevolutions}, Crank Event Time: ${crankEventTime}`);
      console.log(`Previous Timestamp: ${previousTimestamp}, Current Timestamp: ${crankEventTime}`);

      if (previousCrankRevolutions !== null && previousTimestamp !== null) {
        let deltaRevolutions = crankRevolutions - previousCrankRevolutions;
        let deltaTime;

        // ⚠️ Correction du compteur qui reset
        if (crankEventTime < previousTimestamp) {
          console.warn("⚠️ Compteur `crank_event_time` réinitialisé !");
          deltaTime = ((crankEventTime + 65536) - previousTimestamp) / 1024.0;
        } else {
          deltaTime = (crankEventTime - previousTimestamp) / 1024.0;
        }

        console.log(`Raw Delta Time (before scaling): ${crankEventTime - previousTimestamp}`);
        console.log(`Computed Delta Time (seconds): ${deltaTime}`);

        // 🚨 Éviter les deltas trop petits
        if (deltaTime < 0.3) {
          console.warn("⚠️ deltaTime trop petit, on l'ignore pour éviter un pic.");
          return;
        }

        console.log(`Delta Revolutions: ${deltaRevolutions}, Delta Time: ${deltaTime.toFixed(4)} sec`);

        if (deltaTime > 0 && (deltaRevolutions > 0 || Date.now() - lastUpdate >= 3000)) {
          cadence = (deltaRevolutions / deltaTime) * 60;

          // 🔥 Appliquer un **lissage** pour éviter les pics
          const ALPHA = 0; // Facteur de lissage // pas vraiment besoin car déjà lissé au sliding
          cadence = currentCadence ? (cadence * ALPHA + currentCadence * (1 - ALPHA)) : cadence;

          console.log(`Cadence CSCS: ${cadence.toFixed(2)} RPM, last update : ${Date.now() - lastUpdate}`);
          setCurrentCadence(Math.max(0, Math.round(cadence)));
          lastUpdate = Date.now()
          setLastUpdateCad(lastUpdate);

          // Update previous values only when cadence is computed
          previousCrankRevolutions = crankRevolutions;
          previousTimestamp = crankEventTime;
        }
      } else {
        // First data received, just initialize
        previousCrankRevolutions = crankRevolutions;
        previousTimestamp = crankEventTime;
      }
      if (Date.now() - lastUpdate >= 3000) {
        console.warn("🚨 Aucune mise à jour de cadence depuis 3s, reset à 0 !");
        setCurrentCadence(0);
        lastUpdate = Date.now()
        setLastUpdateCad(lastUpdate);
      }
    }


  };

  const subscribeToMetricCP = async (service, withCadence) => {
    // Get the Cycling Power Measurement characteristic
    const characteristic = await service.getCharacteristic(CYCLING_POWER_MEASUREMENT_UUID);

    console.log("Starting notifications CP...");

    // Start listening for updates from the characteristic
    await characteristic.startNotifications();

    // Add the event listener for when the characteristic value changes
    characteristic.addEventListener(
      "characteristicvaluechanged",
      (event) => handleCharacteristicValueChangedCP(event, withCadence)
    );
  };

  const subscribeToMetricCSCS = async (service) => {
    const characteristic = await service.getCharacteristic(CSC_MEASUREMENT_UUID);

    console.log("Starting notifications CSCS...");
    await characteristic.startNotifications();

    characteristic.addEventListener(
      "characteristicvaluechanged",
      handleCharacteristicValueChangedCSCS)
  };

  const handleIndications = (event) => {
    const value = event.target.value; // process your incoming data
    console.log("Received indication:", value);
  };

  const setTargetPowerViaBt = async (service, watts) => {
    if (!canErgControl || !service) {
      console.log(
        `ERG control not available (manual mode). Target was ${Math.round(watts)}W; user must adjust resistance manually.`
      );
      return;
    }
    if (!simulate && service) {
      const controlPointUuid = FITNESS_MACHINE_CONTROL_POINT_UUID;
      const buffer = new ArrayBuffer(3);
      const dataView = new DataView(buffer);
      dataView.setUint8(0, 0x05); // OpCode for Set Target Power
      dataView.setInt16(1, parseInt(Math.round(watts)), true); // Target watts as SINT16, little-endian
      const controlPoint = await service.getCharacteristic(controlPointUuid);
      await controlPoint.writeValue(buffer);
      console.log(
        `Target power set to ${watts} watts to control`,
        controlPoint
      );
    }
    else {
      console.log(
        `Target power simulation set to ${watts} watts to control`);
    }
  };

  const connectToBPM = async () => {
    let device;
    const userAgent = navigator.userAgent || navigator.vendor || window.opera;

    if (isMobile && /iPad|iPhone|iPod/i.test(userAgent) && !window.MSStream) {
      alertDlg(
        "Oops! It looks like iOS devices (iPhone, iPad) don't support Bluetooth on web apps. Unfortunately, this means you won't be able to connect your home trainer. But don't worry! You can still use your computer, including MacBooks, for a seamless experience. Quick reminder: while MacOS > Windows, we all know Android > iOS ;)",
        {
          title: "iOS Bluetooth limitation",
          reportBug: {
            alertName: "HomeTrainerBluetooth: iOS detected (Bluetooth not supported on web apps)",
            fields: ["Device type (iPhone / iPad / Other)"],
            placeholder: "Please confirm:\n- iPhone\n- iPad\n- Other (which?)\n\nOptional: iOS version + browser (ex: iOS 18.2, Safari)",
            sendText: "Send info",
          },
        }
      );
      return;
    }
    else if (!navigator.bluetooth) {
      console.error("Web Bluetooth API is not available in this browser.");
      alertDlg(
        "Web Bluetooth API is not available in this browser. Please use Chrome or another supported browser.",
        {
          title: "Bluetooth not supported on heart sensor",
          reportBug: {
            alertName: "PhoneTab: Web Bluetooth API not available",
            fields: ["Browser type + version (ex: Chrome 131, Edge 131, Safari 18)", "OS (Windows / macOS / Android / iOS)"],
            placeholder: "Example:\nChrome 131 on Windows 11\n\nAnything else helpful (optional):",
            sendText: "Send info",
          },
        }
      );
      return;
    }

    try {
      console.log("User initiated connection for heart rate service...");
      device = await navigator.bluetooth.requestDevice({
        filters: [
          { services: [HEART_RATE_SERVICE_UUID] }, // Heart Rate service
        ],
        optionalServices: [
          HEART_RATE_SERVICE_UUID, // Heart Rate service
        ],
      });

      console.log(`Connecting to ${device.name}`);
      const server = await device.gatt.connect();
      console.log("BPM device connected");

      const service = await server.getPrimaryService(HEART_RATE_SERVICE_UUID);
      console.log("Heart Rate service", service);

      setDeviceBPM(device);
      setServiceBPM(service);

      const heartRateMeasurement = await service.getCharacteristic(HEART_RATE_MEASUREMENT_UUID);
      console.log("Heart Rate Measurement characteristic", heartRateMeasurement);

      // Subscribe to heart rate notifications
      await heartRateMeasurement.startNotifications();
      heartRateMeasurement.addEventListener(
        "characteristicvaluechanged",
        handleCharacteristicValueChangedBPM
      );

      console.log("Subscribed to heart rate notifications");
      setIsBPMConnected(true);
    } catch (error) {
      console.error("Failed to connect BPM:", error);
      setIsBPMConnected(false);
      try {
        if (device?.gatt?.connected) {
          device.gatt.disconnect();
        }
      } catch (e) {
        console.log("Failed to disconnect after error when connecting BPM:", e);
      }
    }
  };

  const disconnectFromBPM = async () => {
    if (!(await confirm("Disconnect heart rate sensor ?"))) {
      return;
    }
    try {
      if (deviceBPM && deviceBPM.gatt && deviceBPM.gatt.connected && serviceBPM) {
        console.log(`Disconnecting from ${deviceBPM.name}...`);

        // Stop notifications and remove event listener
        const heartRateMeasurement = await serviceBPM.getCharacteristic(HEART_RATE_MEASUREMENT_UUID);
        await heartRateMeasurement.stopNotifications();
        heartRateMeasurement.removeEventListener(
          "characteristicvaluechanged",
          handleCharacteristicValueChangedBPM
        );

        deviceBPM.gatt.disconnect();

        console.log("BPM device disconnected");
        // Reset device and service
        setDeviceBPM(null);
        setServiceBPM(null);
        setIsBPMConnected(false);
        setCurrentBPM(null);
      } else {
        console.log("No BPM device is connected.");
      }
    } catch (error) {
      console.error("Failed to disconnect BPM:", error);
    }
  };

  const connectToDevice = async (onConnect, onDisconnect, options = {}) => {

    const useCadenceService = "CSCS" //or CP
    let device;
    const userAgent = navigator.userAgent || navigator.vendor || window.opera;
    const requestedMode = options?.mode === "readOnly" ? "readOnly" : "ftms";

    if (isMobile && /iPad|iPhone|iPod/i.test(userAgent) && !window.MSStream) {
      alertDlg(
        "Oops! It looks like iOS devices (iPhone, iPad) don't support Bluetooth on web apps. Unfortunately, this means you won't be able to connect your home trainer. But don't worry! You can still use your computer, including MacBooks, for a seamless experience. Quick reminder: while MacOS > Windows, we all know Android > iOS ;)",
        {
          title: "iOS Bluetooth limitation",
          reportBug: {
            alertName: "HomeTrainerBluetooth: iOS detected (Bluetooth not supported on web apps)",
            fields: ["Device type (iPhone / iPad / Other)"],
            placeholder: "Please confirm:\n- iPhone\n- iPad\n- Other (which?)\n\nOptional: iOS version + browser (ex: iOS 18.2, Safari)",
            sendText: "Send info",
          },
        }
      );
      return;
    }
    else if (!navigator.bluetooth) {
      console.error("Web Bluetooth API is not available in this browser.");
      alertDlg(
        "Web Bluetooth API is not available in this browser. Please use Chrome or another supported browser.",
        {
          title: "Bluetooth not supported on device",
          reportBug: {
            alertName: "PhoneTab: Web Bluetooth API not available",
            fields: ["Browser type + version (ex: Chrome 131, Edge 131, Safari 18)", "OS (Windows / macOS / Android / iOS)"],
            placeholder: "Example:\nChrome 131 on Windows 11\n\nAnything else helpful (optional):",
            sendText: "Send info",
          },
        }
      ); return;
    }
    try {
      console.log("User initiated connection...");

      const requestFtmsDevice = () =>
        navigator.bluetooth.requestDevice({
          // Prefer the controllable-trainer profile first (FTMS)
          filters: [{ services: [FTMS_SERVICE_UUID] }],
          optionalServices: [FTMS_SERVICE_UUID, CYCLING_POWER_SERVICE_UUID, CSCS_SERVICE_UUID],
        });

      const requestExpandedDevice = () =>
        navigator.bluetooth.requestDevice({
          // Expanded search: show FTMS OR read-only metrics profiles
          filters: [
            { services: [FTMS_SERVICE_UUID] },
            { services: [CYCLING_POWER_SERVICE_UUID] },
            { services: [CSCS_SERVICE_UUID] },
          ],
          optionalServices: [FTMS_SERVICE_UUID, CYCLING_POWER_SERVICE_UUID, CSCS_SERVICE_UUID],
        });

      const connectAndSetup = async (selectedDevice) => {
        const server = await selectedDevice.gatt.connect();
        console.log("Device connected");

        //Only works with acceptAllDevices : true
        //const services = await server.getPrimaryServices();
        //console.log("Services disponibles :");
        //for (const service of services) {
        //    console.log(`Service UUID: ${service.uuid}`);
        //}
        //

        let serviceFTMSLocal = null; // Par défaut à null
        let serviceCSCSLocal = null;
        let serviceCPLocal = null;

        try {
          serviceFTMSLocal = await server.getPrimaryService(FTMS_SERVICE_UUID);
          console.log("serviceFTMS trouvé :", serviceFTMSLocal);
          setCanErgControl(true);
        } catch (error) {
          console.log("serviceFTMS non disponible, serviceFTMS = null");
          setCanErgControl(false);
        }

        try {
          // Needed for power and for some trainers' cadence
          serviceCPLocal = await server.getPrimaryService(CYCLING_POWER_SERVICE_UUID);
          setServiceCP(serviceCPLocal);
          console.log("serviceCP", serviceCPLocal);
        } catch (error) {
          console.log("serviceCP non disponible, serviceCP = null");
          setServiceCP(null);
        }

        if (useCadenceService === "CSCS")  // otherwise not needed at all
        {
          try {
            serviceCSCSLocal = await server.getPrimaryService(CSCS_SERVICE_UUID) // cadence
            setServiceCSCS(serviceCSCSLocal);
            console.log("serviceCSCS", serviceCSCSLocal);
          } catch (error) {
            console.log("serviceCSCS non disponible, serviceCSCS = null");
            setServiceCSCS(null);
            serviceCSCSLocal = null;
          }
        }

        setDeviceHT(selectedDevice);
        setServiceFTMS(serviceFTMSLocal);

        if (serviceFTMSLocal) {
          const controlPointUuid = FITNESS_MACHINE_CONTROL_POINT_UUID; // Fitness Machine Control Point
          try {
            const controlPoint = await serviceFTMSLocal.getCharacteristic(
              controlPointUuid
            );
            controlPoint.addEventListener(
              "characteristicvaluechanged",
              handleIndications
            );
            await controlPoint.startNotifications();
            const buffer = new ArrayBuffer(1); // Buffer for the OpCode
            const dataView = new DataView(buffer);

            // OpCode for Request Control
            dataView.setUint8(0, 0x00); // Assuming 0x00 is the OpCode for Request Control
            console.log("Sending Control request to", controlPoint);
            await controlPoint.writeValue(buffer); //needed ?
            console.log("Control request sent.");
          } catch (error) {
            console.error("Failed to request control", error);
          }
        }
        if (!serviceCPLocal && !serviceCSCSLocal) {
          await alertDlg(
            "We connected to the device, but it doesn't expose Cycling Power (CP) or Speed/Cadence (CSCS).\n\nPlease pick a different device profile (often the one named like your trainer, not a generic sensor).",
            {
              title: "No power/cadence services found",
              reportBug: {
                alertName: "Bluetooth: Connected device has neither CP nor CSCS",
                fields: ["Trainer brand and model", "What device name did you select?"],
                placeholder:
                  "Example:\n- Trainer: ...\n- Selected device name: ...\n\nAnything else helpful (optional):",
                sendText: "Send info",
              },
            }
          );
          throw new Error("No CP/CSCS services available on selected device");
        }

        if (serviceCPLocal) {
          console.log("Subscribing to service CP")
          await subscribeToMetricCP(serviceCPLocal, useCadenceService === "CP");
        }
        if (serviceCSCSLocal) {
          console.log("Subscribing to service CSCS")
          await subscribeToMetricCSCS(serviceCSCSLocal);
        }
        setIsConnected(true);
        console.log("setting set is connected te true");
        onConnect(selectedDevice);

        return { server, serviceFTMSLocal };
      };

      const showReadOnlyInfo = async ({ title }) => {
        await alertDlg(
          "Connected, but ERG control (FTMS) was not available.\n\n" +
          "We'll continue in read-only mode (power/cadence). You can still train here, but you must adjust resistance manually on the trainer.\n\n" +
          "Tips:\n" +
          "- Make sure your trainer supports Bluetooth Low Energy (BLE). Classic Bluetooth / ANT+ won't work in a web browser.\n" +
          "- Make sure your trainer is NOT connected to another app/device (Zwift, TrainerRoad, phone app, head unit, etc.).\n\n" +
          "Please send the info below so we can improve compatibility.",
          {
            title: title || "ERG control not found (FTMS)",
            reportBug: {
              alertName: "Bluetooth: Connected without FTMS (read-only fallback)",
              fields: [
                "Trainer brand and model",
                "Browser + OS",
                "What device name did you select (and what other names were listed)?",
              ],
              placeholder:
                "Example:\n" +
                "- Trainer: Elite Suito\n" +
                "- Browser: Chrome 131\n" +
                "- OS: Windows 11\n" +
                "- Bluetooth list: \"Elite Suito\", \"Elite Suito Power\"...\n" +
                "- Selected: \"Elite Suito Power\"\n\n" +
                "Anything else helpful (optional):",
              sendText: "Send info",
            },
          }
        );
      };

      // Strategy:
      // - If user explicitly requested read-only: go straight to expanded search.
      // - Otherwise: FTMS-only first, then offer expanded search if ERG isn't found / user cancels.
      const doExpandedSearch = async () => {
        try {
          device = await requestExpandedDevice();
        } catch (e) {
          // Cancel / nothing selected in chooser
          if (e?.name === "NotFoundError") {
            await alertDlg(
              "Bluetooth device selection was cancelled.\n\n" +
              "If you want help connecting your trainer, please send the info below (especially what device names you saw).\n\n" +
              "Tips:\n" +
              "- Make sure your trainer supports Bluetooth Low Energy (BLE). Classic Bluetooth / ANT+ won't work in a web browser.\n" +
              "- Make sure your trainer is NOT connected to another app/device (Zwift, TrainerRoad, phone app, head unit, etc.).",
              {
                title: "Bluetooth selection cancelled",
                reportBug: {
                  alertName: "Bluetooth: Expanded search cancelled",
                  fields: [
                    "Trainer brand and model",
                    "Browser + OS",
                    "What device names did you see in the Bluetooth list?",
                    "Why did you cancel? (couldn't find it / too many options / other)",
                  ],
                  placeholder:
                    "Example:\n" +
                    "- Trainer: Elite Suito\n" +
                    "- Browser: Chrome 131\n" +
                    "- OS: Windows 11\n" +
                    "- Bluetooth list: \"Elite Suito\", \"Elite Suito Power\"...\n" +
                    "- Cancel reason: Couldn't find trainer / unsure which to pick\n\n" +
                    "Anything else helpful (optional):",
                  sendText: "Send info",
                },
              }
            );
            // Important: don't fall back to the FTMS troubleshooting modal after the user cancelled
            // the expanded search - we already showed the info dialog.
            const err = new Error("User cancelled expanded search");
            err.code = "EXPANDED_CANCELLED";
            throw err;
          }
          throw e;
        }

        const { serviceFTMSLocal } = await connectAndSetup(device);
        // If FTMS found: connect silently (user shouldn't suspect anything)
        if (!serviceFTMSLocal) {
          await showReadOnlyInfo({ title: "ERG not found - connected read-only" });
        }
      };

      if (requestedMode === "readOnly") {
        await doExpandedSearch();
        return;
      }

      // FTMS-only attempt
      try {
        device = await requestFtmsDevice();
      } catch (e) {
        // Cancel / nothing selected => let UI show the "ERG not found? Expand search" modal
        if (e?.name === "NotFoundError") {
          const err = new Error("User cancelled FTMS connect");
          err.code = "FTMS_CANCELLED";
          throw err;
        }
        throw e;
      }

      const { serviceFTMSLocal } = await connectAndSetup(device);
      // If FTMS filter led to a connection without FTMS (weird but possible), continue read-only and ask for info.
      if (!serviceFTMSLocal) {
        await showReadOnlyInfo({ title: "ERG not found (FTMS)" });
      }

    } catch (error) {
      console.error("Failed to connect:", error);
      onDisconnect();
      setIsConnected(false);
      try {
        device?.gatt?.disconnect();
      } catch (e) {
        console.log("Failed to disconnect after error when connecting:", e);
      }
      throw error;
    } finally { }
  };

  const disconnectFromDevice = async (onDisconnect) => {
    try {
      if (!(await confirm("Disconnect home trainer ?"))) {
        return;
      }
      console.log("User initiated disconnection...");

      if (deviceHT) {
        if (serviceFTMS) {
          try {
            const controlPointUuid = FITNESS_MACHINE_CONTROL_POINT_UUID;
            const characteristic = await serviceFTMS.getCharacteristic(
              controlPointUuid
            );
            await characteristic.stopNotifications();
            characteristic.removeEventListener(
              "characteristicvaluechanged",
              handleIndications
            );
            console.log("Stopped notifications for FTMS service.");
          } catch (error) {
            console.error(
              "Failed to stop notifications for FTMS service:",
              error
            );
          }
        }

        if (serviceCP) {
          try {
            const characteristic = await serviceCP.getCharacteristic(CYCLING_POWER_MEASUREMENT_UUID);
            await characteristic.stopNotifications();
            characteristic.removeEventListener(
              "characteristicvaluechanged",
              handleCharacteristicValueChangedCP
            );
            console.log("Stopped notifications for CP service.");
            setCurrentCadence(null);
            setCurrentPower(null);
          } catch (error) {
            console.error(
              "Failed to stop notifications for CP service:",
              error
            );
          }
        }

        if (serviceCSCS) {
          try {
            const characteristic = await serviceCSCS.getCharacteristic(CSC_MEASUREMENT_UUID);
            await characteristic.stopNotifications();
            characteristic.removeEventListener(
              "characteristicvaluechanged",
              handleCharacteristicValueChangedCSCS
            );
            console.log("Stopped notifications for CSCS service.");
            setCurrentCadence(null);
            setCurrentPower(null);
          } catch (error) {
            console.error(
              "Failed to stop notifications for CSCS service:",
              error
            );
          }
        }

        await deviceHT.gatt.disconnect();
        console.log("Device disconnected.");
      } else {
        console.log("No device is connected.");
      }


      setDeviceHT(null);
      setServiceFTMS(null);
      setServiceCP(null);
      setServiceCSCS(null);
      setIsConnected(false);
      onDisconnect();
    } catch (error) {
      console.error("Failed to disconnect:", error);
    }
  };

  return {
    // Connection state
    isConnected,
    isBPMConnected,
    canErgControl,
    deviceHT,
    deviceBPM,

    // Bluetooth services
    serviceFTMS,
    serviceCP,
    serviceCSCS,
    serviceBPM,

    // Sensor data
    currentCadence,
    currentPower,
    currentBPM,
    lastUpdatePower,
    lastUpdateCad,

    // Debug data
    currentHTValueCP,
    currentHTValueCSCS,

    // Setters (needed by HomeTrainer for simulation + reset flows)
    setServiceFTMS,
    setServiceCP,
    setServiceCSCS,
    setServiceBPM,
    setIsConnected,
    setIsBPMConnected,
    setDeviceHT,
    setDeviceBPM,
    setCurrentCadence,
    setCurrentPower,
    setCurrentBPM,
    setLastUpdatePower,
    setLastUpdateCad,
    setCurrentHTValueCP,
    setCurrentHTValueCSCS,

    // Functions
    connectToDevice,
    disconnectFromDevice,
    setTargetPowerViaBt,
    connectToBPM,
    disconnectFromBPM,
  };
};
